import React, { Component } from 'react'
import Dialog from 'react-bootstrap-dialog'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Loader from 'react-loader-advanced'
import * as Constants from '../../../../common/constants'
import { attendanceTableReady } from '../../redux/attendances'
import { buildNumberUpdate, } from '../../../../redux/user'
import apiService from '../../services/apiservices'



//import * as Helpers from '../../../../common/helpers'

import { EntityType,Reasons } from '../../../../common/DropDowns'

class EditAttendanceModalLayout extends Component {
    constructor() {
        super()
        this.state = {
            reasons: {},
            isUpdating: false,
            type: '',
            reasonId: '',
            remarks: '',

            remarksErrorText: false,
            remarksErrorData: '',

            typeErrorText: false,
            typeErrorData: '',

            reasonIdErrorText: false,
            reasonIdErrorData: '',
        }
        this.dialog = null

        this.isComponentStillMount = true

        this.typeComponent = null
        this.typeSection = null

        this.remarksComponent = null
        this.remarksSection = null

        this.reasonIdComponent = null
        this.reasonIdSection = null
    }

    componentWillMount() {
        this.isComponentStillMount = true
    }

    componentDidMount() {

        this.setState({
            type:this.props.data.type 
        });

        this.typeComponent.value=this.props.data.type 

         this.props.dispatch(attendanceTableReady(false))

            apiService.getAttendanceEditInfo(this.props.data.id)
            .then(attendancesData => {
                if (attendancesData) {
                    this.validateBuildNumber(attendancesData)
                    if (attendancesData.status === "SUCCESS") {
                        if(attendancesData.data.reason && attendancesData.data.reason.name){
                            this.props.dispatch(attendanceTableReady(false))

                            this.dialog.show({
                            title: "Error!!",
                                body: "This attendance is already edited!!",
                                actions: [
                                    Dialog.OKAction(() => {
                                        window.location.reload()
                                    })
                                ],
                            })
                        }
                    }
                }

                this.props.dispatch(attendanceTableReady(true))
            })
            .catch(err => {
                console.error("Error data: ", err)
                this.props.dispatch(attendanceTableReady(true))                
            })
    }


mandateValidation = (inputName, type) => {
    let inputComponent = inputName + "Component"
    let inputErrorText = inputName + "ErrorText"
    let inputErrorData = inputName + "ErrorData"
    let inputSection = inputName + "Section"
    let errorMsg = Constants.NON_VALID_MSG_INPUT
    if (Constants.FORM_SELECT === type) {
        errorMsg = Constants.NON_VALID_MSG_SELECT
        console.log("input name :::", inputName)
        console.log("input data :::", this.state[inputName])
    }
    if (this.state[inputName] === null || this.state[inputName] === undefined || this.state[inputName] === "") {
        this[inputComponent].focus()
        this.setState({
            [inputErrorText]: true,
            [inputErrorData]: errorMsg
        })
        this[inputSection].className = this[inputSection].className.replace(" has-error", "")
        this[inputSection].className += " has-error"
        return {
            status: false,
            value: ''
        }
    }
    return {
        status: true
    }
}

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }

    componentWillUnmount() {
        this.isComponentStillMount = false
    }


    handleChanges = () => {
    }

    submitData = () => {
        let data = {}
        data.create_again=0
        
        
    }


    handleOnChange = (e) => {
   
        this.setState({
           file : e.target.files[0] 
        });
    };

     entityTypeChange= (data) => {
    
        this.typeComponent.value=data.value
    
        this.setState({
            type :data.value,
            typeErrorText: false,
            typeErrorData: ''
        })
            
        this.typeSection.className= this.typeSection.className.replace(" has-error", "")
    }

     reasonChange= (data) => {
    
        this.reasonIdComponent.value=data.value
    
        this.setState({
            reasonId :data.value,
            reasonIdErrorText: false,
            reasonIdErrorData: ''
        })
            
        this.reasonIdSection.className= this.reasonIdSection.className.replace(" has-error", "")
    }




    

    handleOnSubmit = (e) => {

        e.preventDefault();

        this.props.dispatch(attendanceTableReady(false))
        let data = {}




        let typeObject = this.mandateValidation("type", Constants.FORM_SELECT)
        if (typeObject.status) {
            data.type=this.typeComponent.value         

        } else {
            this.props.dispatch(attendanceTableReady(true))
            return
        }


        if(this.typeComponent.value===this.props.data.type){

            this.props.dispatch(attendanceTableReady(true))
            this.dialog.show({
                            title: "Alert",
                            body: "Attendance type hasn't changed",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
        }
  
    
        let reasonIdObject = this.mandateValidation("reasonId", Constants.FORM_SELECT)
        if (reasonIdObject.status) {
            data.reason_id = this.reasonIdComponent.value
        } else {

             this.props.dispatch(attendanceTableReady(true))
            return
        }


    
        let remarksObject = this.mandateValidation("remarks", Constants.FORM_INPUT)
        if (remarksObject.status) {
            data.remarks = this.remarksComponent.value
        } else {

             this.props.dispatch(attendanceTableReady(true))
            return
        }
    


    let apiPayloadData=data;


    apiService.editAttendance(apiPayloadData,this.props.data.id)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(attendanceTableReady(true))
                        this.props.closeModal(false)
                        window.location.reload()
                    } else {

                        this.props.dispatch(attendanceTableReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(attendanceTableReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })




}



  
    render() {

        return (
            <div className="qr-code-reader-modal">
                <Dialog ref={el => this.dialog = el} />
                <Loader
                    show={this.state.isUpdating}
                    message={'Updating...Please wait'}
                    foregroundStyle={{ color: "#ffffff", fontSize: "17px", fontWeight: "600" }}>
                    <div className="modal-header">
                        <button type="button" className="close"
                            onClick={(e) => {
                                e.preventDefault()
                                this.props.closeModal(false)
                            }}>
                            <span>&times;</span></button>
                        <h4 className="modal-title">Update Attendance of :  {this.props.data.employee_name} [ {this.props.data.attendance_date} ]</h4>
                    </div>

                    <div className="modal-body">
                            <div className="form-horizontal">

                                            <div className="col-md-12 col-sm-12 col-xs-12 statusDrodown">
                                                    <div className="col-md-11 col-sm-12 col-xs-12">
                                                        <div className="form-group" ref={el =>
                                                           this.typeSection = el}>
                                                           <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "5px"}}>Status *</label>
                                                            <div className="col-sm-9" ref={el =>
                                                              this.typeComponent = el}>
                                                              <EntityType type="ATTENDANCE" entityTypeChange={this.entityTypeChange} selectedValue={this.state.type} />
                                                              <span className="help-block" style={{ display: this.state.typeErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                                                              {this.state.typeErrorData}
                                                              </span>
                                                            </div>
                                                        </div>
                                                    </div>                                          
                                            </div>

                                            <div className="col-md-12 col-sm-12 col-xs-12 reasonDrodown">
                                                            <div className="col-md-11 col-sm-12 col-xs-12">
                                                                <div className="form-group" ref={el =>
                                                                       this.reasonIdSection = el}>
                                                                       <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Reason *</label>
                                                                       
                                                             <div className="col-sm-9" ref={el =>
                                                                      this.reasonIdComponent = el}>
                                                                      <Reasons type="ATTENDANCE" reasonChange={this.reasonChange} selectedValue={this.state.reasonId} />
                                                                      <span className="help-block" style={{ display: this.state.reasonIdErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                                                                      {this.state.reasonIdErrorData}
                                                                      </span>
                                                                    </div>
                                                                    </div>
                                                            </div>                                          
                                                    </div>

                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-11 col-sm-12 col-xs-12">
                                            <div className="form-group" ref={el => this.remarksSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Remarks *</label>
                                                    <div className="col-sm-9">
                                                        <textarea className="form-control" placeholder="Enter Remarks" type="text" ref={el => this.remarksComponent = el}
                                                            onChange={(e) => {e.preventDefault() 
                                                            this.keyedInputChange("remarks")}} />
                                                        <span className="help-block"style={{display: this.state.remarksErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.remarksErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>


                            </div>
                    </div>
                    <div className="modal-footer" style={{marginTop: "13%"}}>
                        <button type="button" className="btn btn-primary pull-left"
                            onClick={(e) => {
                                e.preventDefault()
                                this.props.closeModal(false)
                            }}>Close</button>
                            <button
                                    className="btn btn-info pull-right"
                                    style={{ width: "auto" }}
                                    onClick={(e) => {
                                        e.preventDefault()
                                        this.handleOnSubmit(e);
                                    }} >
                                    Submit
                                </button>
                    </div>

            </Loader>
            </div>
        )
    }


    keyedInputChange = (keyedName) => {
        console.log(keyedName)
        let keyedComponent =keyedName+"Component"
        let keyedErrorText =keyedName+"ErrorText"
        let keyedErrorData =keyedName+"ErrorData"
        let keyedSection =keyedName+"Section"
        let name=this[keyedComponent].value.trim()
        this.setState({[keyedName]:name})
        if(!name){
            this.setState({[keyedName] : null})
            return
        }
        this.setState({ [keyedErrorText]: false, [keyedErrorData]: '' })
        this[keyedSection].className = this[keyedSection].className.replace(" has-error", "")
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
        attendances: state.attendances,
    }
}

export default connect(mapStateToProps)(withRouter(EditAttendanceModalLayout))


// WEBPACK FOOTER //
// ./src/modules/Attendance/Components/ModalLayout/EditAttendanceModalLayout.js